__turbopack_context__.v({
  "categoriesGrid": "DesktopCategoriesDropdown-module__NV87FG__categoriesGrid",
  "categoryIcon": "DesktopCategoriesDropdown-module__NV87FG__categoryIcon",
  "categoryItem": "DesktopCategoriesDropdown-module__NV87FG__categoryItem",
  "categoryName": "DesktopCategoriesDropdown-module__NV87FG__categoryName",
  "dropdownContainer": "DesktopCategoriesDropdown-module__NV87FG__dropdownContainer",
  "open": "DesktopCategoriesDropdown-module__NV87FG__open",
});
